<template>
  <!-- 云稼政务 -->
  <div>
    <el-carousel :height="computeHeight">
      <el-carousel-item v-for="(item, index) in sliders" :key="index">
        <img :src="item.img" class="banner" />
      </el-carousel-item>
    </el-carousel>

    <!-- 数字乡村管理平台 -->
    <div class="manage_parent">
      <div class="manage_title">功能强大的数字乡村管理平台</div>
      <div class="manage_info">
        云稼数字乡村解决方案通过搭建数字指挥舱，以及提供基层党建、政务办公、民生服务、乡村治理等服务，帮助政府不断完善数字乡村智能化数字化、技术化建设，加强信息资源整合共享与利用，助力乡村振兴。
      </div>
      <div class="manage_card">
        <el-row :gutter="20" type="flex" style="flex-wrap: wrap">
          <el-col :span="8">
            <div class="manage_border">
              <img class="manage_img" :src="manage[0].img" />
              <div class="manage_right">
                <div class="title">{{ manage[0].title }}</div>
                <div class="content">{{ manage[0].content[0] }}</div>
                <div class="content">{{ manage[0].content[1] }}</div>
                <div class="content">
                  {{ manage[0].content[2] }}
                </div>
              </div>
            </div>
          </el-col>
          <el-col :span="8">
            <div class="manage_border">
              <img class="manage_img" :src="manage[1].img" />
              <div class="manage_right">
                <div class="title">{{ manage[1].title }}</div>
                <div class="content">{{ manage[1].content[0] }}</div>
              </div>
            </div>
          </el-col>
          <el-col :span="8">
            <div class="manage_border">
              <img class="manage_img" :src="manage[2].img" />
              <div class="manage_right">
                <div class="title">{{ manage[2].title }}</div>
                <div class="content">{{ manage[2].content[0] }}</div>
              </div>
            </div>
          </el-col>
          <el-col :span="8">
            <div class="manage_border">
              <img class="manage_img" :src="manage[3].img" />
              <div class="manage_right">
                <div class="title">{{ manage[3].title }}</div>
                <div class="content">{{ manage[3].content[0] }}</div>
                <div class="content">{{ manage[3].content[1] }}</div>
              </div>
            </div>
          </el-col>
          <el-col :span="8">
            <div class="manage_border">
              <img class="manage_img" :src="manage[4].img" />
              <div class="manage_right">
                <div class="title">{{ manage[4].title }}</div>
                <div class="content">覆盖PC\APP\小程序数据大屏等多个渠道</div>
              </div>
            </div>
          </el-col>
          <el-col :span="8">
            <div class="manage_border">
              <img class="manage_img" :src="manage[5].img" />
              <div class="manage_right">
                <div class="title">{{ manage[5].title }}</div>
                <div class="content">{{ manage[5].content[0] }}</div>
              </div>
            </div>
          </el-col>
        </el-row>
      </div>
    </div>

    <!-- 中部内容切换 -->
    <div class="tab_parent">
      <el-tabs v-model="activeName" stretch>
        <el-tab-pane label="党政建设" name="first">
          <el-carousel
            indicator-position="none"
            height="760px"
            v-if="activeName == 'first'"
          >
            <!-- 应用场景 -->
            <el-carousel-item>
              <div class="scene_parent">
                <img
                  src="../../../static/other/bg_scene_top.png"
                  class="bg_scene_top"
                />
                <img
                  src="../../../static/other/ic_scene_top.png"
                  class="scene_center"
                />
                <div class="scene_bottom">
                  <div class="scene_bottom_title">
                    满足各行业党建工作需求 开启智慧党务新时代
                  </div>
                  <div class="scene_bottom_content">
                    创新智慧党建新模式，为基层各级党组织提供党员管理、党务督办、党建活动组织和宣传展示等丰富的党建应用，并融合各级党组织数据，形成完整的基层党建工作平台，加强基层党组织建设，不断提高党建工作科学化、信息化水平，以党建引领乡村振兴
                  </div>
                </div>
              </div>
            </el-carousel-item>
            <!-- 平台设计 -->
            <el-carousel-item>
              <div class="design_parent">
                <div class="design_top">
                  8大平台设计<br />全面展示和推进党建工作
                </div>
                <div class="design_bottom">
                  <div class="bg_design_parent">
                    <el-row :gutter="20" type="flex" style="flex-wrap: wrap">
                      <el-col
                        :span="6"
                        v-for="(item, index) in design_item"
                        :key="index"
                      >
                        <div class="design_item">
                          <div class="bg_design_item">
                            <div class="design_item_title">
                              {{ item.title }}
                            </div>
                            <div class="design_item_content">
                              {{ item.content }}
                            </div>
                            <div class="design_item_content">
                              {{ item.content_two }}
                            </div>
                          </div>
                          <img :src="item.img" class="design_item_img" />
                        </div>
                      </el-col>
                    </el-row>
                  </div>
                </div>
              </div>
            </el-carousel-item>
            <!-- 优势 -->
            <el-carousel-item>
              <div class="advantage_parent">
                <div class="advantage_top">轻松做好党务6大优势</div>
                <div class="advantage_top_two">好用 实用 管用</div>
                <!-- 蓝底背景 -->
                <div class="advantage_bottom">
                  <!-- 白底背景 -->
                  <div class="advantage_bottom_bg">
                    <!-- 上半部分 -->
                    <div class="advantage_bottom_parent">
                      <div class="advantage_bottom_item">
                        <img
                          class="advantage_item_img"
                          :src="advantage_item[0].img"
                        />
                        <div class="advantage_item_right">
                          <div class="advantage_item_title">
                            {{ advantage_item[0].title }}
                          </div>
                          <div class="advantage_item_content">
                            {{ advantage_item[0].content }}
                          </div>
                          <div class="advantage_item_content">
                            {{ advantage_item[0].content_two }}
                          </div>
                          <div class="advantage_item_content">
                            {{ advantage_item[0].content_three }}
                          </div>
                        </div>
                      </div>
                      <div class="line" />
                      <div class="advantage_bottom_item">
                        <img
                          class="advantage_item_img"
                          :src="advantage_item[1].img"
                        />
                        <div class="advantage_item_right">
                          <div class="advantage_item_title">
                            {{ advantage_item[1].title }}
                          </div>
                          <div class="advantage_item_content">
                            {{ advantage_item[1].content }}
                          </div>
                        </div>
                      </div>
                      <div class="line" />
                      <div class="advantage_bottom_item">
                        <img
                          class="advantage_item_img"
                          :src="advantage_item[2].img"
                        />
                        <div class="advantage_item_right">
                          <div class="advantage_item_title">
                            {{ advantage_item[2].title }}
                          </div>
                          <div class="advantage_item_content">
                            {{ advantage_item[2].content }}
                          </div>
                        </div>
                      </div>
                    </div>
                    <div
                      style="height: 1px; width: 100%; background: #e5e7eb"
                    />
                    <!-- 下半部分 -->
                    <div class="advantage_bottom_parent">
                      <div class="advantage_bottom_item">
                        <img
                          class="advantage_item_img"
                          :src="advantage_item[3].img"
                        />
                        <div class="advantage_item_right">
                          <div class="advantage_item_title">
                            {{ advantage_item[3].title }}
                          </div>
                          <div class="advantage_item_content">
                            {{ advantage_item[3].content }}
                          </div>
                        </div>
                      </div>
                      <div class="line" />
                      <div class="advantage_bottom_item">
                        <img
                          class="advantage_item_img"
                          :src="advantage_item[4].img"
                        />
                        <div class="advantage_item_right">
                          <div class="advantage_item_title">
                            {{ advantage_item[4].title }}
                          </div>
                          <div class="advantage_item_content">
                            {{ advantage_item[4].content }}
                          </div>
                        </div>
                      </div>
                      <div class="line" />
                      <div class="advantage_bottom_item">
                        <img
                          class="advantage_item_img"
                          :src="advantage_item[5].img"
                        />
                        <div class="advantage_item_right">
                          <div class="advantage_item_title">
                            {{ advantage_item[5].title }}
                          </div>
                          <div class="advantage_item_content">
                            {{ advantage_item[5].content }}
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </el-carousel-item>
          </el-carousel>
        </el-tab-pane>
        <el-tab-pane label="政务办公" name="second">
          <el-carousel
            indicator-position="none"
            height="760px"
            v-if="activeName == 'second'"
          >
            <!-- 应用丰富 -->
            <el-carousel-item>
              <div class="apply_parent">
                <div class="apply_title">产品应用丰富</div>
                <div class="apply_info">
                  围绕政府部门“办文、办会、办事”等核心管理工作，全面覆盖政府多层级组织管理、公文管理会议管理、督查督办、信息管理、内务管理等政务办公与事务处理应用
                </div>
                <div class="apply_bottom">
                  <div class="apply_bottom_center">
                    <div class="apply_bottom_parent">
                      <div class="apply_bottom_item bg_apply_bottom_item1">
                        <div class="apply_bottom_item_top">
                          <img
                            class="apply_bottom_item_img"
                            :src="apply_item[0].img"
                          />
                          <div class="apply_bottom_item_title">
                            {{ apply_item[0].title }}
                          </div>
                        </div>
                        <div class="apply_bottom_item_content">
                          {{ apply_item[0].content }}
                        </div>
                      </div>
                      <div class="apply_bottom_item bg_apply_bottom_item2">
                        <div class="apply_bottom_item_top">
                          <img
                            class="apply_bottom_item_img"
                            :src="apply_item[1].img"
                          />
                          <div class="apply_bottom_item_title">
                            {{ apply_item[1].title }}
                          </div>
                        </div>
                        <div class="apply_bottom_item_content">
                          {{ apply_item[1].content }}
                        </div>
                      </div>
                      <div class="apply_bottom_item bg_apply_bottom_item3">
                        <div class="apply_bottom_item_top">
                          <img
                            class="apply_bottom_item_img"
                            :src="apply_item[2].img"
                          />
                          <div class="apply_bottom_item_title">
                            {{ apply_item[2].title }}
                          </div>
                        </div>
                        <div class="apply_bottom_item_content">
                          {{ apply_item[2].content }}
                        </div>
                      </div>
                      <div class="apply_bottom_item bg_apply_bottom_item4">
                        <div class="apply_bottom_item_top">
                          <img
                            class="apply_bottom_item_img"
                            :src="apply_item[3].img"
                          />
                          <div class="apply_bottom_item_title">
                            {{ apply_item[3].title }}
                          </div>
                        </div>
                        <div class="apply_bottom_item_content">
                          {{ apply_item[3].content }}
                        </div>
                      </div>
                    </div>
                    <div class="apply_bottom_parent">
                      <div class="apply_bottom_item bg_apply_bottom_item5">
                        <div class="apply_bottom_item_top">
                          <img
                            class="apply_bottom_item_img"
                            :src="apply_item[4].img"
                          />
                          <div class="apply_bottom_item_title">
                            {{ apply_item[4].title }}
                          </div>
                        </div>
                        <div class="apply_bottom_item_content">
                          {{ apply_item[4].content }}
                        </div>
                      </div>
                      <div class="apply_bottom_item bg_apply_bottom_item6">
                        <div class="apply_bottom_item_top">
                          <img
                            class="apply_bottom_item_img"
                            :src="apply_item[5].img"
                          />
                          <div class="apply_bottom_item_title">
                            {{ apply_item[5].title }}
                          </div>
                        </div>
                        <div class="apply_bottom_item_content">
                          {{ apply_item[5].content }}
                        </div>
                      </div>
                      <div class="apply_bottom_item bg_apply_bottom_item7">
                        <div class="apply_bottom_item_top">
                          <img
                            class="apply_bottom_item_img"
                            :src="apply_item[6].img"
                          />
                          <div class="apply_bottom_item_title">
                            {{ apply_item[6].title }}
                          </div>
                        </div>
                        <div class="apply_bottom_item_content">
                          {{ apply_item[6].content }}
                        </div>
                      </div>
                      <div class="apply_bottom_item bg_apply_bottom_item8">
                        <div class="apply_bottom_item_top">
                          <img
                            class="apply_bottom_item_img"
                            :src="apply_item[7].img"
                          />
                          <div class="apply_bottom_item_title">
                            {{ apply_item[7].title }}
                          </div>
                        </div>
                        <div class="apply_bottom_item_content">
                          {{ apply_item[7].content }}
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </el-carousel-item>

            <el-carousel-item>
              <div class="worth_parent">
                <div class="worth_title">5大价值支撑</div>
                <div class="worth_bottom">
                  <div class="worth_bottom_center">
                    <div @mouseleave="mouseleave1" @mouseenter="mouseenter1">
                      <div
                        class="worth_item_hint bg_worth_item_hint1"
                        v-if="isShowWorth1"
                      >
                        <div
                          class="
                            worth_item_hint_top
                            bg_worth_item_hint_top_left
                          "
                        >
                          <img
                            class="worth_item_hint_img"
                            :src="worth_item[0].img"
                          />
                          <div class="worth_item_hint_title">
                            {{ worth_item[0].title_two }}
                          </div>
                        </div>
                        <div class="worth_item_hint_content">
                          {{ worth_item[0].content_two }}
                        </div>
                      </div>
                      <div
                        class="worth_item_show bg_worth_item_show_left"
                        v-if="!isShowWorth1"
                      >
                        <div class="worth_item_show_top">
                          <img
                            class="worth_item_show_img"
                            :src="worth_item[0].img"
                          />
                          <div class="worth_item_show_title">
                            {{ worth_item[0].title }}
                          </div>
                        </div>
                        <div
                          class="worth_item_bottom_title"
                          id="worth_item_bottom_title"
                          v-for="(item, index) in worth_item[0].content"
                          :key="index"
                        >
                          {{ item }}
                        </div>
                      </div>
                    </div>

                    <div @mouseleave="mouseleave2" @mouseenter="mouseenter2">
                      <div
                        class="worth_item_hint bg_worth_item_hint2"
                        v-if="isShowWorth2"
                      >
                        <div
                          class="
                            worth_item_hint_top
                            bg_worth_item_hint_top_center
                          "
                        >
                          <img
                            class="worth_item_hint_img"
                            :src="worth_item[1].img"
                          />
                          <div class="worth_item_hint_title">
                            {{ worth_item[1].title_two }}
                          </div>
                        </div>
                        <div class="worth_item_hint_content">
                          {{ worth_item[1].content_two }}
                        </div>
                      </div>
                      <div
                        class="worth_item_show bg_worth_item_show_center"
                        v-if="!isShowWorth2"
                      >
                        <div class="worth_item_show_top">
                          <img
                            class="worth_item_show_img"
                            :src="worth_item[1].img"
                          />
                          <div class="worth_item_show_title">
                            {{ worth_item[1].title }}
                          </div>
                        </div>
                        <div
                          class="worth_item_bottom_title"
                          id="worth_item_bottom_title"
                          v-for="(item, index) in worth_item[1].content"
                          :key="index"
                        >
                          {{ item }}
                        </div>
                      </div>
                    </div>

                    <div @mouseleave="mouseleave3" @mouseenter="mouseenter3">
                      <div
                        class="worth_item_hint bg_worth_item_hint2"
                        v-if="isShowWorth3"
                      >
                        <div
                          class="
                            worth_item_hint_top
                            bg_worth_item_hint_top_center
                          "
                        >
                          <img
                            class="worth_item_hint_img"
                            :src="worth_item[2].img"
                          />
                          <div class="worth_item_hint_title">
                            {{ worth_item[2].title_two }}
                          </div>
                        </div>
                        <div class="worth_item_hint_content">
                          {{ worth_item[2].content_two }}
                        </div>
                      </div>
                      <div
                        class="worth_item_show bg_worth_item_show_center"
                        v-if="!isShowWorth3"
                      >
                        <div class="worth_item_show_top">
                          <img
                            class="worth_item_show_img"
                            :src="worth_item[2].img"
                          />
                          <div class="worth_item_show_title">
                            {{ worth_item[2].title }}
                          </div>
                        </div>
                        <div
                          class="worth_item_bottom_title"
                          id="worth_item_bottom_title"
                          v-for="(item, index) in worth_item[2].content"
                          :key="index"
                        >
                          {{ item }}
                        </div>
                      </div>
                    </div>

                    <div @mouseleave="mouseleave4" @mouseenter="mouseenter4">
                      <div
                        class="worth_item_hint bg_worth_item_hint2"
                        v-if="isShowWorth4"
                      >
                        <div
                          class="
                            worth_item_hint_top
                            bg_worth_item_hint_top_center
                          "
                        >
                          <img
                            class="worth_item_hint_img"
                            :src="worth_item[3].img"
                          />
                          <div class="worth_item_hint_title">
                            {{ worth_item[3].title_two }}
                          </div>
                        </div>
                        <div class="worth_item_hint_content">
                          {{ worth_item[3].content_two }}
                        </div>
                      </div>
                      <div
                        class="worth_item_show bg_worth_item_show_center"
                        v-if="!isShowWorth4"
                      >
                        <div class="worth_item_show_top">
                          <img
                            class="worth_item_show_img"
                            :src="worth_item[3].img"
                          />
                          <div class="worth_item_show_title">
                            {{ worth_item[3].title }}
                          </div>
                        </div>
                        <div
                          class="worth_item_bottom_title"
                          id="worth_item_bottom_title"
                          v-for="(item, index) in worth_item[3].content"
                          :key="index"
                        >
                          {{ item }}
                        </div>
                      </div>
                    </div>

                    <div @mouseleave="mouseleave5" @mouseenter="mouseenter5">
                      <div
                        class="worth_item_hint bg_worth_item_hint3"
                        v-if="isShowWorth5"
                      >
                        <div
                          class="
                            worth_item_hint_top
                            bg_worth_item_hint_top_right
                          "
                        >
                          <img
                            class="worth_item_hint_img"
                            :src="worth_item[4].img"
                          />
                          <div class="worth_item_hint_title">
                            {{ worth_item[4].title_two }}
                          </div>
                        </div>
                        <div class="worth_item_hint_content">
                          {{ worth_item[4].content_two }}
                        </div>
                      </div>
                      <div
                        class="worth_item_show bg_worth_item_show_right"
                        v-if="!isShowWorth5"
                      >
                        <div class="worth_item_show_top">
                          <img
                            class="worth_item_show_img"
                            :src="worth_item[4].img"
                          />
                          <div class="worth_item_show_title">
                            {{ worth_item[4].title }}
                          </div>
                        </div>
                        <div
                          class="worth_item_bottom_title"
                          id="worth_item_bottom_title"
                          v-for="(item, index) in worth_item[4].content"
                          :key="index"
                        >
                          {{ item }}
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </el-carousel-item>
            <!-- 产品特点 -->
            <el-carousel-item>
              <div class="trait_parent">
                <div class="trait_title">产品特点</div>
                <div class="trait_bottom">
                  <div class="trait_bottom_center">
                    <div class="trait_bottom_center_item_parent">
                      <div
                        class="trait_bottom_center_item"
                        v-show="showTrait_parent"
                      >
                        <div
                          class="trait_item bg_trait_item1"
                          @mouseenter="trait_mouseenter1"
                        >
                          <img
                            class="trait_item_img"
                            :src="trait_item[0].img"
                          />
                          <div class="trait_item_text">
                            灵活强劲的<br />一体化平台
                          </div>
                        </div>
                        <div
                          class="trait_item bg_trait_item4"
                          @mouseenter="trait_mouseenter2"
                        >
                          <img
                            class="trait_item_img"
                            :src="trait_item[3].img"
                          />
                          <div class="trait_item_text">
                            多端业务协作<br />消息一触即达
                          </div>
                        </div>
                      </div>

                      <div
                        class="
                          trait_bottom_center_hint_item
                          trait_bottom_center_hint_left
                        "
                        v-show="showTrait_item"
                        @mouseleave="trait_mouseleave1"
                      >
                        <img
                          class="trait_hint_item_img"
                          :src="trait_item[0].img"
                        />
                        <div class="trait_hint_item_title">
                          灵活强劲的<br />一体化平台
                        </div>
                        <div class="trait_hint_item_info">
                          整合数据资源，覆盖不同领域的业务办公场景，打造一体化的业务集成和应用开发平台
                        </div>
                      </div>

                      <div
                        class="
                          trait_bottom_center_hint_item
                          trait_bottom_center_hint_left
                        "
                        v-show="showTrait_item2"
                        @mouseleave="trait_mouseleave2"
                      >
                        <img
                          class="trait_hint_item_img"
                          :src="trait_item[3].img"
                        />
                        <div class="trait_hint_item_title">
                          多端业务协作<br />消息一触即达
                        </div>
                        <div class="trait_hint_item_info">
                          集成移动平台业务，打造数据共享、消息直达、多端同时协作的电子政务办公应用
                        </div>
                      </div>
                    </div>

                    <div class="trait_bottom_center_item_parent">
                      <div class="trait_bottom_center_item"  v-show="showTrait_parent2">
                        <div class="trait_item bg_trait_item2" @mouseenter="trait_mouseenter3">
                          <img
                            class="trait_item_img"
                            :src="trait_item[1].img"
                          />
                          <div class="trait_item_text">
                            智慧协同 <br />轻松办公
                          </div>
                        </div>
                        <div class="trait_item bg_trait_item5" @mouseenter="trait_mouseenter4">
                          <img
                            class="trait_item_img"
                            :src="trait_item[4].img"
                          />
                          <div class="trait_item_text">
                            海量应用<br />随需定制
                          </div>
                        </div>
                      </div>

                      <div
                        class="
                          trait_bottom_center_hint_item
                          trait_bottom_center_hint_center
                        "
                        v-show="showTrait_item3"
                        @mouseleave="trait_mouseleave3"
                      >
                        <img
                          class="trait_hint_item_img"
                          :src="trait_item[1].img"
                        />
                        <div class="trait_hint_item_title">
                          智慧协同 <br />轻松办公
                        </div>
                        <div class="trait_hint_item_info">
                          遵循国家公文管理相关规范与标准，设计办文、办会、办事等政务业务功能，让行政办公全程电子化，让管理制度有效落地执行
                        </div>
                      </div>

                      <div
                        class="
                          trait_bottom_center_hint_item
                          trait_bottom_center_hint_center
                        "
                        v-show="showTrait_item4"
                        @mouseleave="trait_mouseleave4"
                      >
                        <img
                          class="trait_hint_item_img"
                          :src="trait_item[4].img"
                        />
                        <div class="trait_hint_item_title">
                          海量应用<br />随需定制
                        </div>
                        <div class="trait_hint_item_info">
                          应用模块化灵活组合，减少复杂的业务功能，强化核心要素，提供性能稳定的搜索工具，随需应变，满足个性化需求
                        </div>
                      </div>
                    </div>

                    <div class="trait_bottom_center_item_parent">
                      <div class="trait_bottom_center_item" v-show="showTrait_parent3">
                        <div class="trait_item bg_trait_item3"  @mouseenter="trait_mouseenter5">
                          <img
                            class="trait_item_img"
                            :src="trait_item[2].img"
                          />
                          <div class="trait_item_text">
                            自主安全<br />权威认证
                          </div>
                        </div>
                        <div class="trait_item bg_trait_item6"  @mouseenter="trait_mouseenter6">
                          <img
                            class="trait_item_img"
                            :src="trait_item[5].img"
                          />
                          <div class="trait_item_text">
                            业务指引<br />快速响应
                          </div>
                        </div>
                      </div>

                      <div
                        class="
                          trait_bottom_center_hint_item
                          trait_bottom_center_hint_right
                        "
                        v-show="showTrait_item5"
                        @mouseleave="trait_mouseleave5"
                      >
                        <img
                          class="trait_hint_item_img"
                          :src="trait_item[2].img"
                        />
                        <div class="trait_hint_item_title">
                          自主安全<br />权威认证
                        </div>
                        <div class="trait_hint_item_info">
                          严格按照国家信息安全等保分保相关要求，业务操作实时记录，历史数据支持追溯
                        </div>
                      </div>

                      <div
                        class="
                          trait_bottom_center_hint_item
                          trait_bottom_center_hint_right
                        "
                        v-show="showTrait_item6"
                        @mouseleave="trait_mouseleave6"
                      >
                        <img
                          class="trait_hint_item_img"
                          :src="trait_item[5].img"
                        />
                        <div class="trait_hint_item_title">
                          业务指引<br />快速响应
                        </div>
                        <div class="trait_hint_item_info">
                          简化产品设计逻辑、浅化业务操作入口，突出重要信息并引导用户操作，降低学习成本，帮助用户快速掌握信息化协作方法
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </el-carousel-item>
          </el-carousel>
        </el-tab-pane>
        <el-tab-pane label="便民服务" name="third">
          <el-carousel
            indicator-position="none"
            height="760px"
            v-if="activeName == 'third'"
          >
            <!-- 管理系统 -->
            <el-carousel-item>
              <div class="system_parent">
                <div class="system_title">一体化便民行政管理系统</div>
                <div class="system_info">
                  实现一门受理，协同办理，让群众少跑腿，让数据多跑路。整合区域内各行政事项，实现多部门数据共享各部门业务协同，不断拓宽网上服务渠道，真正提升行政效率，助推优化公共服务，有效保障行政审批工作的高效开展
                </div>
                <div class="system_bottom">
                  <div class="system_center">
                    <img
                      class="system_img"
                      src="../../../static/other/ic_system_bottom.png"
                    />
                  </div>
                </div>
              </div>
            </el-carousel-item>

            <!-- 服务内容 -->
            <el-carousel-item>
              <div class="system_parent">
                <div class="system_title">丰富的便民服务内容</div>
                <div class="system_info">
                  便民服务功能强，涵盖内容全面，
                  集便民服务、办件查询、办事指南、政务公开、投诉工作评价等多种功能事项于一体逐步可实现足不出户掌上随时随地办，使得公众办理政务就像网购一样方便
                </div>
                <div class="system_bottom">
                  <div class="system_content_center">
                    <img
                      class="service_content_img"
                      src="../../../static/other/ic_service_content.png"
                    />
                    <el-row
                      :gutter="40"
                      type="flex"
                      style="
                        flex-wrap: wrap;
                        width: 60%;
                        height: 300px;
                        margin-top: 80px;
                        margin-left: 30px;
                      "
                    >
                      <el-col
                        :span="6"
                        v-for="(item, index) in system_content"
                        :key="index"
                      >
                        <div class="system_content_item">
                          <img class="system_content_img" :src="item.img" />
                          <div class="system_content_text">
                            {{ item.title }}
                          </div>
                        </div>
                      </el-col>
                    </el-row>
                  </div>
                </div>
              </div>
            </el-carousel-item>

            <!-- 核心优势 -->
            <el-carousel-item>
              <div class="core_advantage_parent">
                <div class="core_advantage_title">核心优势</div>
                <div class="core_advantage_bottom">
                  <div class="core_advantage_center">
                    <div class="core_advantage_item">
                      <img
                        class="core_advantage_item_img"
                        :src="core_advantage_item[0].img"
                      />
                      <div class="core_advantage_item_title">
                        {{ core_advantage_item[0].title }}
                      </div>
                      <div class="core_advantage_item_content">
                        {{ core_advantage_item[0].content }}
                      </div>
                    </div>
                    <div class="line" />
                    <div class="core_advantage_item">
                      <img
                        class="core_advantage_item_img"
                        :src="core_advantage_item[1].img"
                      />
                      <div class="core_advantage_item_title">
                        {{ core_advantage_item[1].title }}
                      </div>
                      <div class="core_advantage_item_content">
                        {{ core_advantage_item[1].content }}
                      </div>
                    </div>
                    <div class="line" />
                    <div class="core_advantage_item">
                      <img
                        class="core_advantage_item_img"
                        :src="core_advantage_item[2].img"
                      />
                      <div class="core_advantage_item_title">
                        {{ core_advantage_item[2].title }}
                      </div>
                      <div class="core_advantage_item_content">
                        {{ core_advantage_item[2].content }}
                      </div>
                    </div>
                    <div class="line" />
                    <div class="core_advantage_item">
                      <img
                        class="core_advantage_item_img"
                        :src="core_advantage_item[3].img"
                      />
                      <div class="core_advantage_item_title">
                        {{ core_advantage_item[3].title }}
                      </div>
                      <div class="core_advantage_item_content">
                        {{ core_advantage_item[3].content }}
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </el-carousel-item>
          </el-carousel>
        </el-tab-pane>
        <el-tab-pane label="乡村治理" name="fourth">
          <el-carousel
            indicator-position="none"
            height="760px"
            v-if="activeName == 'fourth'"
          >
            <!-- 数字化乡村管理建设 -->
            <el-carousel-item>
              <div class="village_parent">
                <div class="village_title">数字化乡村管理建设</div>
                <div class="village_info">
                  根据现代化新农村建设需求，以互联网+技术为依托实现中国数字化乡村管理建设，
                  一网统筹管理，将人、地、情、物、事、组织进行结合
                  <br />利用多渠道数据采集，校对、分析后实现标准化整合，覆盖各社区、各行政村，实现统一调度指挥、协同高效联动
                  <br />促进信息化与乡村治理融合，提升乡村治理的智能化、精细化和专业化水平
                </div>
                <div class="village_bottom">
                  <div class="village_center">
                    <div class="village_construction_left">
                      <div class="village_construction_left_title">
                        覆盖政府、村干部、居民三类角色
                      </div>
                      <img
                        class="village_construction_left_img"
                        src="../../../static/other/ic_village_construction.png"
                      />
                    </div>
                    <div class="village_construction_right">
                      <div class="village_construction_right_title">
                        应用功能丰富 全面覆盖乡村各项工作
                      </div>
                      <el-row
                        :gutter="40"
                        type="flex"
                        style="flex-wrap: wrap; width: 80%; height: 150px"
                      >
                        <el-col
                          :span="8"
                          v-for="(item, index) in village_construction_content"
                          :key="index"
                        >
                          <div class="village_construction_right_item">
                            <img
                              class="village_construction_right_item_img"
                              src="../../../static/other/ic_village_construction_right_item.png"
                            />
                            <div class="village_construction_right_item_text">
                              {{ item }}
                            </div>
                          </div>
                        </el-col>
                      </el-row>
                    </div>
                  </div>
                </div>
              </div>
            </el-carousel-item>
            <!-- 构建四大产品 -->
            <el-carousel-item>
              <div class="village_parent">
                <div class="village_title">构建四大产品</div>
                <div class="village_info">
                  构建四大产品入口 打通服务村民最后一米
                </div>
                <div class="village_bottom">
                  <div class="village_product_center">
                    <el-row :gutter="20" type="flex" style="flex-wrap: wrap">
                      <el-col
                        :span="6"
                        v-for="(item, index) in village_product_content"
                        :key="index"
                      >
                        <div class="village_product_item">
                          <img
                            class="village_product_item_img"
                            :src="item.img"
                          />
                          <div class="village_product_item_title">
                            {{ item.title }}
                          </div>
                          <div class="village_product_item_content">
                            {{ item.content }}
                          </div>
                        </div>
                      </el-col>
                    </el-row>
                  </div>
                </div>
              </div>
            </el-carousel-item>
            <!-- 连接性 -->
            <el-carousel-item>
              <div class="village_parent">
                <div class="village_title">强大的连接性 直接触达C端</div>
                <div class="village_info">连接政府 连接村干部 连接村民</div>
                <div class="village_bottom">
                  <div class="village_center village_connectivity_padding">
                    <div class="village_connectivity">
                      <div class="village_connectivity_title">
                        三级体系 互联管控
                      </div>
                      <div class="village_connectivity_info">
                        区县、乡/镇/街道、村（社区）三级管理实现各类服务的互联管控和信息数据联动
                      </div>
                      <div class="village_connectivity_title">
                        数字政务 高效协同
                      </div>
                      <div class="village_connectivity_info">
                        融入丰富的基层治理与服务应用实现基层组织、经办、治理的高效协同
                      </div>
                    </div>
                    <div class="village_connectivity_bg">
                      <img
                        class="village_connectivity_img"
                        src="../../../static/other/ic_village_connectivity_center.png"
                      />
                    </div>

                    <div class="village_connectivity">
                      <div class="village_connectivity_title">
                        连接居民 智慧服务
                      </div>
                      <div class="village_connectivity_info">
                        多种路径触达居民 提升信息传递效率打通平台内外
                        提供智慧化的精准服务
                      </div>
                      <div class="village_connectivity_title">
                        数据赋能 科学决策
                      </div>
                      <div class="village_connectivity_info">
                        形成区综合治理、应急、人口等数据大屏呈现基层运营全貌，为数字治理提供支持
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </el-carousel-item>
          </el-carousel>
        </el-tab-pane>
      </el-tabs>
    </div>
  </div>
</template>
<script>
export default {
  name: "Government",
  data() {
    return {
      sliders: [
        {
          // img: require("../../../static/slider/a1.png"),
          img: require("../../../static/slider/banner.png"),

        },
      ],
      manage: [
        {
          img: require("../../../static/other/ic_manage1.png"),
          title: "使用范围广",
          content: [
            "系统操作简单",
            "适用范围广",
            "覆盖政府、企业、农民、消费者等多方使用",
          ],
        },
        {
          img: require("../../../static/other/ic_manage2.png"),
          title: "功能丰富",
          content: ["多种政务、企业办公服务应用，满足办公多种需求"],
        },
        {
          img: require("../../../static/other/ic_manage3.png"),
          title: "本地化部署",
          content: ["根据客户要求，支持本地化部署，自主运营"],
        },
        {
          img: require("../../../static/other/ic_manage1.png"),
          title: "快速实施",
          content: ["产品成熟", "可快速部署"],
        },
        {
          img: require("../../../static/other/ic_manage5.png"),
          title: "全终端覆盖",
        },
        {
          img: require("../../../static/other/ic_manage6.png"),
          title: "定制服务",
          content: ["结合当地基层实际需求，功能可定制可扩展"],
        },
      ],
      activeName: "first",
      design_item: [
        {
          img: require("../../../static/other/ic_design_item1.png"),
          title: "宣传平台",
          content: "打造互联网宣传新媒体",
          content_two: "实现党建信息及时共享",
        },
        {
          img: require("../../../static/other/ic_design_item2.png"),
          title: "学习平台",
          content: "一站式学习平台",
          content_two: "在线学习全记录",
        },
        {
          img: require("../../../static/other/ic_design_item3.png"),
          title: "党务平台",
          content: "对党建动态进行跟踪",
          content_two: "便捷党群事物处理",
        },
        {
          img: require("../../../static/other/ic_design_item4.png"),
          title: "工作平台",
          content: "提升党务工作效率",
          content_two: "减少工作重复性",
        },
        {
          img: require("../../../static/other/ic_design_item5.png"),
          title: "交流平台",
          content: "打破以往活动封闭状态",
          content_two: "充分调动党员交流互动",
        },
        {
          img: require("../../../static/other/ic_design_item6.png"),
          title: "活动平台",
          content: "组织记录党务活动",
          content_two: "实现数据在线可查",
        },
        {
          img: require("../../../static/other/ic_design_item7.png"),
          title: "监督平台",
          content: "搭配可视化系统",
          content_two: "实现线上监管和管控",
        },
        {
          img: require("../../../static/other/ic_design_item8.png"),
          title: "管理平台",
          content: "可视化平台",
          content_two: "工作进展一目了然",
        },
      ],
      advantage_item: [
        {
          img: require("../../../static/other/ic_advantage_bottom_item1.png"),
          title: "基层减负",
          content: "数据互通，避免文山会海",
          content_two: "简单易用，增强工作效率",
          content_three: "智慧管理，基层党建易上手",
        },
        {
          img: require("../../../static/other/ic_advantage_bottom_item2.png"),
          title: "加强监管",
          content: "可视化实时监督，多维度预警提醒，强化担当抓落实",
        },
        {
          img: require("../../../static/other/ic_advantage_bottom_item3.png"),
          title: "精准分析",
          content:
            "全方位、多角度、多维度党务大数据智能分析，挖掘数据价值，分析发展趋势、辅助领导决策",
        },
        {
          img: require("../../../static/other/ic_advantage_bottom_item4.png"),
          title: "规范管理",
          content: "全面落实上级规范性文件要求，实现党务工作全场精细化管理",
        },
        {
          img: require("../../../static/other/ic_advantage_bottom_item5.png"),
          title: "功能丰富",
          content:
            "集学习、服务、管理、监管、考核、分析等功能于一体，充分满足各行业需求",
        },
        {
          img: require("../../../static/other/ic_advantage_bottom_item6.png"),
          title: "高效智能",
          content: "信息化手段提高党务工作效能，提升党务工作水平",
        },
      ],
      apply_item: [
        {
          img: require("../../../static/other/ic_apply_bottom1.png"),
          title: "公文管理",
          content:
            "在线拟稿收文、发文、交换、移动签批，让政令高效流转，辅助工作高效开展",
        },
        {
          img: require("../../../static/other/ic_apply_bottom2.png"),
          title: "会议管理",
          content:
            "实现签到、纪要、议题、决议、督办等全过程闭环会议管理，移动会议让开会更简单",
        },
        {
          img: require("../../../static/other/ic_apply_bottom3.png"),
          title: "督查督办",
          content:
            "涵盖立项、反馈、看板、评价等督办板块，支撑督办全流程管理，实时督办更灵活",
        },
        {
          img: require("../../../static/other/ic_apply_bottom4.png"),
          title: "内务管理",
          content:
            "将文件管理、人事考勤、用印、后勤接待等管理与服务应用集中打造成一体化、移动化、智慧化的政务平台",
        },
        {
          img: require("../../../static/other/ic_apply_bottom5.png"),
          title: "信息管理",
          content:
            "核心在于信息分类化推送，同时也是一个应用信息整合平台，将内部、外部、互联网三网信息融合应用",
        },
        {
          img: require("../../../static/other/ic_apply_bottom6.png"),
          title: "合同管理",
          content:
            "覆盖合同管理全生命周期，实现合同前期、签订、履约及归档的全流程管理，提升合同管理审批效率",
        },
        {
          img: require("../../../static/other/ic_apply_bottom7.png"),
          title: "个人办公",
          content:
            "把我要办的、我已办的、跟踪的、关注的公文、会议、审批、日程以推送、提醒的方式直观展现给用户",
        },
        {
          img: require("../../../static/other/ic_apply_bottom8.png"),
          title: "党建管理",
          content:
            "采用“互联网＋”模式，向科学党建的方式转变，最终形成组织内部的“移动智慧党建”平台",
        },
      ],
      worth_item: [
        {
          img: require("../../../static/other/ic_worth_item1.png"),
          title: "协同办公",
          content: ["跨部门", "跨层级", "跨地区", "共享公用", "多级并用"],
          title_two: "政令通达 协同办公",
          content_two:
            "大力推进党政机关跨部门、跨层级，跨地区协同，实现业务系统融合与人的融合，打造共享公用、多级并用的—体化协同办公系统",
        },
        {
          img: require("../../../static/other/ic_worth_item2.png"),
          title: "数据支撑",
          content: [
            "全流程",
            "数据汇聚",
            "提高工作效率",
            "提高工作质量",
            "提升服务水平",
          ],
          title_two: "数据支撑 科学决策",
          content_two:
            "汇聚办文、办事、办会等各方面的数据、通过全流程的网上办公大大缩短办事时间，把数据作为提高工作效率、评价工作质量、提升服务水平重要依据",
        },
        {
          img: require("../../../static/other/ic_worth_item3.png"),
          title: "流程规范",
          content: ["规范流程", "规避漏洞", "信息安全", "管理高效"],
          title_two: "流程规范 管理高效",
          content_two:
            "潜在的流程显性化，随意的流程固定化、固定的流程高效化。规范流程使用、避免安全漏洞及风险.保障党政机关信息安全",
        },
        {
          img: require("../../../static/other/ic_worth_item4.png"),
          title: "有据可查",
          content: ["有据可查", "实时留痕", "有效预防", "防范四风"],
          title_two: "有据可查 防范四风",
          content_two:
            "平台绩效考核有据可查，办文、办会、办事实时留痕，有效预防'庸、懒、散、慢'四风，破除形式主义、官僚主义等工作作风",
        },
        {
          img: require("../../../static/other/ic_worth_item5.png"),
          title: "数据安全",
          content: ["身份认证", "安全审计", "数据加密", "设备管理"],
          title_two: "数据安全 自主可控",
          content_two:
            "从系统的身份认证、授权、安全审计、数据加密、设备管理等多个方面建立了完整的安全保密防护设计",
        },
      ],
      showTrait_parent: true,
      showTrait_parent2: true,
      showTrait_parent3: true,
      showTrait_item1: false,
      showTrait_item2: false,
      showTrait_item3: false,
      showTrait_item4: false,
      showTrait_item5: false,
      showTrait_item6: false,
      trait_item: [
        {
          img: require("../../../static/other/ic_trait_item1.png"),
        },
        {
          img: require("../../../static/other/ic_trait_item2.png"),
        },
        {
          img: require("../../../static/other/ic_trait_item3.png"),
        },
        {
          img: require("../../../static/other/ic_trait_item4.png"),
        },
        {
          img: require("../../../static/other/ic_trait_item5.png"),
        },
        {
          img: require("../../../static/other/ic_trait_item6.png"),
        },
      ],
      isShowWorth1: false,
      isShowWorth2: false,
      isShowWorth3: false,
      isShowWorth4: false,
      isShowWorth5: false,
      system_content: [
        {
          img: require("../../../static/other/ic_service_content_item1.png"),
          title: "社会保障",
        },
        {
          img: require("../../../static/other/ic_service_content_item2.png"),
          title: "法律援助",
        },
        {
          img: require("../../../static/other/ic_service_content_item3.png"),
          title: "气象环保",
        },
        {
          img: require("../../../static/other/ic_service_content_item4.png"),
          title: "公积金",
        },
        {
          img: require("../../../static/other/ic_service_content_item5.png"),
          title: "交通出行",
        },
        {
          img: require("../../../static/other/ic_service_content_item6.png"),
          title: "医疗卫生",
        },
        {
          img: require("../../../static/other/ic_service_content_item7.png"),
          title: "创业就业",
        },
        {
          img: require("../../../static/other/ic_service_content_item8.png"),
          title: "农林牧渔",
        },
        {
          img: require("../../../static/other/ic_service_content_item9.png"),
          title: "税务服务",
        },
        {
          img: require("../../../static/other/ic_service_content_item10.png"),
          title: "工程建设",
        },
        {
          img: require("../../../static/other/ic_service_content_item11.png"),
          title: "市场监管",
        },
        {
          img: require("../../../static/other/ic_service_content_item12.png"),
          title: "文化旅游",
        },
      ],
      core_advantage_item: [
        {
          img: require("../../../static/other/ic_core_advantage_item1.png"),
          title: "信息传播快",
          content:
            "可发布政策解读、服务内容和信息公示，同时又能通过查询和消息推送，及时跟进办事进度，从而避免不必要的误解，及时掌握政策信息",
        },
        {
          img: require("../../../static/other/ic_core_advantage_item2.png"),
          title: "工作效率高",
          content:
            "通过APP/小程序等提供便民服务，减少线下沟通和排队成本，不仅方便了民众办事，减轻了公务人员的工作量，同时也提升了服务的效率和体验",
        },
        {
          img: require("../../../static/other/ic_core_advantage_item3.png"),
          title: "应用功能多",
          content:
            "APP/小程序可添加各种应用插件，能满足信息展示、客服咨询、在线预约、数据接入、问答等，可满足各种场景下的服务需要，提供齐全的配套服务，让办事不用跑断腿",
        },
        {
          img: require("../../../static/other/ic_core_advantage_item4.png"),
          title: "简单易操作",
          content:
            "根据便民服务流程来编制程序，系统功能条理清晰，结构严谨，简单易懂，操作界面使用方便，下载即用，再加上用户粘性，能真正做到让政务服务留在民众手边",
        },
      ],
      village_construction_content: [
        "政务工作",
        "调查走访",
        "通知通告",
        "信访上报",
        "村务管理",
        "土地资产",
        "村民管理",
        "乡村旅游",
      ],
      village_product_content: [
        {
          img: require("../../../static/other/ic_village_product1.png"),
          title: "云端管理后台",
          content: "构建基层信息库和应用库",
        },
        {
          img: require("../../../static/other/ic_village_product2.png"),
          title: "居民微信群",
          content: "直接触达居民，实现柔性服务",
        },
        {
          img: require("../../../static/other/ic_village_product3.png"),
          title: "居民小程序",
          content: "居民信息与服务窗口",
        },
        {
          img: require("../../../static/other/ic_village_product4.png"),
          title: "数字大屏",
          content: "数据分析助力基层科学决策",
        },
      ],
    };
  },

  mounted() {},
  methods: {
    mouseenter1() {
      this.isShowWorth1 = true;
    },
    mouseleave1() {
      this.isShowWorth1 = false;
    },
    mouseenter2() {
      this.isShowWorth2 = true;
    },
    mouseleave2() {
      this.isShowWorth2 = false;
    },
    mouseenter3() {
      this.isShowWorth3 = true;
    },
    mouseleave3() {
      this.isShowWorth3 = false;
    },
    mouseenter4() {
      this.isShowWorth4 = true;
    },
    mouseleave4() {
      this.isShowWorth4 = false;
    },
    mouseenter5() {
      this.isShowWorth5 = true;
    },
    mouseleave5() {
      this.isShowWorth5 = false;
    },

    //产品特色控制显隐
    trait_mouseenter1() {
      this.showTrait_parent = false;
      this.showTrait_item = true;
    },
    trait_mouseleave1() {
      this.showTrait_parent = true;
      this.showTrait_item = false;
    },
    trait_mouseenter2() {
      this.showTrait_parent = false;
      this.showTrait_item2 = true;
    },
    trait_mouseleave2() {
      this.showTrait_parent = true;
      this.showTrait_item2 = false;
    },
    trait_mouseenter3() {
      this.showTrait_parent2 = false;
      this.showTrait_item3 = true;
    },
    trait_mouseleave3() {
      this.showTrait_parent2 = true;
      this.showTrait_item3 = false;
    },
    trait_mouseenter4() {
      this.showTrait_parent2 = false;
      this.showTrait_item4 = true;
    },
    trait_mouseleave4() {
      this.showTrait_parent2 = true;
      this.showTrait_item4 = false;
    },
    trait_mouseenter5() {
      this.showTrait_parent3 = false;
      this.showTrait_item5 = true;
    },
    trait_mouseleave5() {
      this.showTrait_parent3 = true;
      this.showTrait_item5 = false;
    },
    trait_mouseenter6() {
      this.showTrait_parent3 = false;
      this.showTrait_item6 = true;
    },
    trait_mouseleave6() {
      this.showTrait_parent3 = true;
      this.showTrait_item6 = false;
    },
  },
  computed: {
    //计算高度
    computeHeight() {
      let screenHeight = document.body.clientWidth;
      if (screenHeight > 415) {
        return "500px";
      } else {
        return "250px";
      }
    },
  },
};
</script>

<style lang="scss" scoped>
.banner {
  width: 100%;
  height: 100%;
}

.manage_parent {
  background: #f6f7fc;
  display: flex;
  justify-content: center;
  align-items: center;
  flex-direction: column;
  padding-top: 80px;
  padding-bottom: 80px;

  .manage_title {
    width: 400px;
    font-family: "PingFang SC";
    font-weight: 500;
    margin-bottom: 8px;
    font-size: 28px;
    text-align: center;
    color: #333333;
  }
  .manage_info {
    width: 950px;
    font-family: "PingFang SC";
    font-weight: 400;
    font-size: 16px;
    line-height: 22px;
    text-align: center;
    margin-bottom: 48px;
    color: #666666;
  }

  .manage_card {
    width: 70%;
    margin: auto;

    .manage_border {
      height: 210px;
      border-radius: 10px;
      border: 1px solid #ebeef5;
      margin-bottom: 10px;
      margin-top: 10px;
      display: flex;
      flex-direction: row;
      align-items: center;
      box-shadow: 0 2px 12px 0 rgba(0, 0, 0, 0.1);

      .manage_img {
        width: 56px;
        height: 56px;
        margin-left: 28px;
        margin-right: 28px;
      }
      .manage_right {
        display: flex;
        height: 150px;
        margin-right: 25px;
        flex-direction: column;
        justify-content: flex-start;

        .title {
          font-family: "PingFang SC";
          font-weight: 500;
          font-size: 20px;
          color: #000000;
          margin-bottom: 8px;
        }
        .content {
          // width: 230px;
          margin-bottom: 8px;
          font-family: "PingFang SC";
          font-weight: 400;
          font-size: 16px;
          color: #666666;
        }
      }
    }
  }
}

.tab_parent {
  background: #fff;
  margin-bottom: 50px;
  >>> .el-tabs__nav-scroll {
    width: 70%;
    margin: 0 auto;
  }

  //底部线宽度颜色
  >>> .el-tabs__nav-wrap::after {
    height: 1px;
    background: #cccccc;
  }

  // 默认样式
  >>> .el-tabs__item {
    height: 100px;
    line-height: 100px;
    text-align: center;
    font-size: 26px;
    font-weight: 400;
    color: rgba(0, 0, 0, 0.5);
  }

  /*选中样式*/
  >>> .el-tabs__item.is-active {
    height: 100px;
    line-height: 100px;
    text-align: center;
    font-weight: 400;
    color: #3982f7;
  }

  //切换tab宽度
  >>> .el-tabs__active-bar {
    height: 4px;
  }
  >>> .el-carousel__arrow--left {
    left: 80px;
  }
  >>> .el-carousel__arrow--right {
    right: 80px;
  }
  .scene_parent {
    display: flex;
    flex-direction: column;
    align-items: center;

    .scene_center {
      width: 10%;
      height: auto;
      position: absolute;
      top: 180px;
      left: 0;
      right: 0;
      margin: 0px auto;
    }

    .bg_scene_top {
      width: 50%;
      height: auto;
      margin-top: 70px;
    }

    .scene_bottom {
      width: 100%;
      height: 480px;
      display: flex;
      flex-direction: column;
      align-items: center;
      background: url("../../../static/other/bg_scene_bottom.png");
      background-repeat: no-repeat;
      background-size: cover;
      background-position: center 0;

      .scene_bottom_title {
        width: auto;
        font-family: "PingFang SC";
        font-weight: 500;
        font-size: 28px;
        line-height: 39px;
        color: #ffffff;
        margin-top: 150px;
        margin-bottom: 46px;
      }

      .scene_bottom_content {
        font-family: "PingFang SC";
        width: 920px;
        font-weight: 400;
        font-size: 16px;
        line-height: 22px;
        text-align: center;
        color: #ffffff;
      }
    }
  }

  .design_parent {
    display: flex;
    flex-direction: column;

    .design_top {
      font-family: "PingFang SC";
      font-weight: 500;
      font-size: 28px;
      margin-top: 80px;
      margin-bottom: 48px;
      line-height: 39px;
      text-align: center;
      color: #333333;
    }

    .design_bottom {
      width: 100%;
      height: 536px;
      background: url("../../../static/other/bg_policy_bottom.png");
      background-repeat: no-repeat;
      background-size: cover;
      background-position: center 0;
      display: flex;
      justify-content: center;

      .bg_design_parent {
        width: 60%;
        padding-top: 24px;
      }

      .design_item {
        position: relative;
        margin-top: 32px;
        width: 100%;
        height: 188px;

        .design_item_img {
          position: absolute;
          width: 64px;
          height: 64px;
          left: 0;
          right: 0;
          margin: 0px auto;
        }

        .bg_design_item {
          display: flex;
          position: absolute;
          margin-top: 32px;
          flex-direction: column;
          width: 100%;
          height: 156px;
          background: #ffffff;
          border-radius: 8px;

          .design_item_title {
            font-family: "PingFang SC";
            font-weight: 500;
            font-size: 18px;
            line-height: 25px;
            margin-bottom: 8px;
            margin-top: 50px;
            text-align: center;
            color: #333333;
          }

          .design_item_content {
            font-family: "PingFang SC";
            font-weight: 400;
            font-size: 14px;
            line-height: 20px;
            text-align: center;
            color: #333333;
          }
        }
      }
    }
  }

  .advantage_parent {
    display: flex;
    flex-direction: column;
    justify-content: center;

    .advantage_top {
      font-family: "PingFang SC";
      font-weight: 500;
      font-size: 28px;
      line-height: 39px;
      margin-top: 80px;
      margin-bottom: 8px;
      text-align: center;
      color: #333333;
    }
    .advantage_top_two {
      font-family: "PingFang SC";
      font-weight: 400;
      font-size: 16px;
      line-height: 22px;
      margin-bottom: 48px;
      text-align: center;
      color: #666666;
    }
    .advantage_bottom {
      width: 100%;
      height: 536px;
      background: url("../../../static/other/bg_policy_bottom.png");
      background-repeat: no-repeat;
      background-size: cover;
      background-position: center 0;
      display: flex;
      justify-content: center;
      align-items: center;

      .advantage_bottom_bg {
        width: 65%;
        height: 401px;
        background: #ffffff;
        border-radius: 8px;
        display: flex;
        flex-direction: column;

        .advantage_bottom_parent {
          display: flex;
          flex-direction: row;
          .advantage_bottom_item {
            display: flex;
            width: 33%;
            height: 200px;
            flex-direction: row;
            .advantage_item_img {
              width: 48px;
              height: 48px;
              margin-left: 32px;
              margin-right: 24px;
              margin-top: 66px;
            }
            .advantage_item_right {
              display: flex;
              flex-direction: column;
              margin-top: 32px;

              .advantage_item_title {
                font-family: "PingFang SC";
                font-weight: 500;
                font-size: 18px;
                margin-bottom: 12px;
                line-height: 25px;
                color: #333333;
              }
              .advantage_item_content {
                font-family: "PingFang SC";
                font-weight: 400;
                font-size: 16px;
                line-height: 22px;
                margin-bottom: 6px;
                margin-right: 20px;
                color: #666666;
              }
            }
          }
          .line {
            height: 200px;
            width: 1px;
            background: #e5e7eb;
          }
        }
      }
    }
  }

  .apply_parent {
    display: flex;
    flex-direction: column;
    justify-content: center;
    align-items: center;

    .apply_title {
      margin-top: 80px;
      margin-bottom: 8px;
      font-family: "PingFang SC";
      font-weight: 500;
      font-size: 28px;
      color: #333333;
    }
    .apply_info {
      width: 658px;
      font-family: "PingFang SC";
      font-weight: 400;
      font-size: 16px;
      line-height: 22px;
      text-align: center;
      color: #666666;
      margin-bottom: 48px;
    }
    .apply_bottom {
      width: 100%;
      height: 536px;
      display: flex;
      justify-content: center;
      background: url("../../../static/other/bg_apply_bottom.png");
      background-repeat: no-repeat;
      background-size: cover;
      background-position: center 0;

      .apply_bottom_center {
        margin-top: 68px;
        display: flex;
        flex-direction: column;
        .apply_bottom_parent {
          display: flex;
          flex-direction: row;
          .apply_bottom_item {
            width: 271px;
            height: 200px;
            display: flex;
            flex-direction: column;

            .apply_bottom_item_top {
              display: flex;
              flex-direction: row;
              margin-left: 32px;
              margin-top: 32px;
              .apply_bottom_item_img {
                width: 32px;
                height: 32px;
              }
              .apply_bottom_item_title {
                font-family: "PingFang SC";
                font-weight: 500;
                font-size: 18px;
                margin-left: 8px;
                line-height: 32px;
                color: #ffffff;
              }
            }
            .apply_bottom_item_content {
              font-family: "PingFang SC";
              margin-top: 10px;
              margin-left: 32px;
              margin-right: 32px;
              font-weight: 400;
              font-size: 16px;
              line-height: 22px;
              color: rgba(255, 255, 255, 0.8);
            }
          }

          .bg_apply_bottom_item1 {
            background: url("../../../static/other/bg_apply_bottom_item1.png");
          }
          .bg_apply_bottom_item2 {
            background: url("../../../static/other/bg_apply_bottom_item2.png");
          }
          .bg_apply_bottom_item3 {
            background: url("../../../static/other/bg_apply_bottom_item3.png");
          }
          .bg_apply_bottom_item4 {
            background: url("../../../static/other/bg_apply_bottom_item4.png");
          }
          .bg_apply_bottom_item5 {
            background: url("../../../static/other/bg_apply_bottom_item5.png");
          }
          .bg_apply_bottom_item6 {
            background: url("../../../static/other/bg_apply_bottom_item6.png");
          }
          .bg_apply_bottom_item7 {
            background: url("../../../static/other/bg_apply_bottom_item7.png");
          }
          .bg_apply_bottom_item8 {
            background: url("../../../static/other/bg_apply_bottom_item8.png");
          }
        }
      }
    }
  }

  .worth_parent {
    display: flex;
    flex-direction: column;

    .worth_title {
      font-family: "PingFang SC";
      font-weight: 500;
      font-size: 28px;
      line-height: 39px;
      text-align: center;
      margin-top: 80px;
      margin-bottom: 48px;
      color: #333333;
    }

    .worth_bottom {
      width: 100%;
      height: 536px;
      display: flex;
      justify-content: center;
      background: url("../../../static/other/bg_apply_bottom.png");
      background-repeat: no-repeat;
      background-size: cover;
      background-position: center 0;

      .worth_bottom_center {
        margin-top: 68px;
        display: flex;
        flex-direction: row;

        .bg_worth_item_show_left {
          background: url("../../../static/other/bg_worth_item_show1.png");
        }

        .bg_worth_item_show_center {
          background: url("../../../static/other/bg_worth_item_show2.png");
        }

        .bg_worth_item_show_right {
          background: url("../../../static/other/bg_worth_item_show3.png");
        }

        .bg_worth_item_hint_top_left {
          background: url("../../../static/other/bg_worth_item_hint_top1.png");
        }

        .bg_worth_item_hint_top_center {
          background: url("../../../static/other/bg_worth_item_hint_top2.png");
        }

        .bg_worth_item_hint_top_right {
          background: url("../../../static/other/bg_worth_item_hint_top3.png");
        }

        .bg_worth_item_hint1 {
          background: url("../../../static/other/bg_worth_item_hint1.png");
        }

        .bg_worth_item_hint2 {
          background: url("../../../static/other/bg_worth_item_hint2.png");
        }
        .bg_worth_item_hint3 {
          background: url("../../../static/other/bg_worth_item_hint3.png");
        }

        .worth_item_hint {
          width: 280px;
          height: 400px;
          display: flex;
          flex-direction: column;
          position: relative;

          .worth_item_hint_top {
            display: flex;
            flex-direction: row;
            justify-content: center;
            align-items: center;
            height: 92px;

            .worth_item_hint_img {
              width: 28px;
              height: 28px;
              margin-right: 9px;
            }

            .worth_item_hint_title {
              font-family: "PingFang SC";
              font-style: normal;
              font-weight: 500;
              font-size: 18px;
              line-height: 28px;
              text-align: center;
              color: #ffffff;
            }
          }

          .worth_item_hint_content {
            font-family: "PingFang SC";
            font-weight: 400;
            font-size: 16px;
            color: #ffffff;
            line-height: 24px;
            margin-left: 32px;
            margin-top: 24px;
            margin-right: 32px;
          }
        }

        .worth_item_show {
          display: flex;
          flex-direction: column;
          width: 201px;
          height: 400px;

          .worth_item_show_top {
            display: flex;
            flex-direction: row;
            margin-bottom: 56px;
            margin-top: 32px;
            margin-left: 32px;

            .worth_item_show_title {
              font-family: "PingFang SC";
              font-style: normal;
              font-weight: 500;
              font-size: 18px;
              line-height: 28px;
              text-align: center;
              color: #ffffff;
            }
            .worth_item_show_img {
              width: 28px;
              height: 28px;
              margin-right: 9px;
            }
          }

          div[id="worth_item_bottom_title"]:before {
            content: "●";
            color: rgba(255, 255, 255, 0.8);
          }

          .worth_item_bottom_title {
            font-family: "PingFang SC";
            font-weight: 400;
            font-size: 16px;
            margin-bottom: 24px;
            margin-left: 32px;
            color: rgba(255, 255, 255, 0.8);
          }
        }
      }
    }
  }

  .trait_parent {
    display: flex;
    flex-direction: column;

    .trait_title {
      font-family: "PingFang SC";
      font-weight: 500;
      font-size: 28px;
      line-height: 39px;
      text-align: center;
      margin-top: 80px;
      margin-bottom: 48px;
      color: #333333;
    }

    .trait_bottom {
      width: 100%;
      height: 536px;
      display: flex;
      justify-content: center;
      background: url("../../../static/other/bg_apply_bottom.png");
      background-repeat: no-repeat;
      background-size: cover;
      background-position: center 0;

      .trait_bottom_center {
        display: flex;
        flex-direction: row;
        margin-top: 68px;
        .trait_bottom_center_item_parent {
          width: 361px;
          height: 400px;
          display: flex;
        }

        .trait_bottom_center_item {
          display: flex;
          flex-direction: column;

          .bg_trait_item1 {
            background: url("../../../static/other/bg_trait_item1.png");
          }

          .bg_trait_item2 {
            background: url("../../../static/other/bg_trait_item2.png");
          }

          .bg_trait_item3 {
            background: url("../../../static/other/bg_trait_item3.png");
          }

          .bg_trait_item4 {
            background: url("../../../static/other/bg_trait_item4.png");
          }

          .bg_trait_item5 {
            background: url("../../../static/other/bg_trait_item5.png");
          }

          .bg_trait_item6 {
            background: url("../../../static/other/bg_trait_item6.png");
          }

          .trait_item {
            display: flex;
            flex-direction: column;
            align-items: center;
            width: 361px;
            height: 200px;

            .trait_item_img {
              width: 48px;
              height: 48px;
              margin-top: 44px;
              margin-bottom: 8px;
            }
            .trait_item_text {
              font-family: "PingFang SC";
              font-weight: 400;
              font-size: 20px;
              line-height: 28px;
              color: #ffffff;
            }
          }
        }

        .trait_bottom_center_hint_item {
          width: 361px;
          height: 400px;
          display: flex;
          flex-direction: column;
          align-items: center;
          position: absolute;
          z-index: 10;

          .trait_hint_item_img {
            width: 48px;
            height: 48px;
            margin-top: 44px;
            margin-bottom: 8px;
          }
          .trait_hint_item_title {
            font-family: "PingFang SC";
            font-weight: 400;
            font-size: 20px;
            line-height: 28px;
            color: #ffffff;
          }
          .trait_hint_item_info {
            font-family: "PingFang SC";
            font-weight: 400;
            font-size: 16px;
            line-height: 22px;
            color: #ffffff;
            width: 241px;
            margin-top: 32px;
          }
        }

        .trait_bottom_center_hint_left {
          background: url("../../../static/other/bg_trait_bottom_center_hint_left.png");
        }
        .trait_bottom_center_hint_center {
          background: url("../../../static/other/bg_trait_bottom_center_hint_center.png");
        }
        .trait_bottom_center_hint_right {
          background: url("../../../static/other/bg_trait_bottom_center_hint_right.png");
        }
      }
    }
  }

  .system_parent {
    display: flex;
    flex-direction: column;
    justify-content: center;
    align-items: center;

    .system_title {
      font-family: "PingFang SC";
      font-weight: 500;
      font-size: 28px;
      line-height: 39px;
      margin-top: 80px;
      margin-bottom: 8px;
      color: #333333;
    }
    .system_info {
      width: 838px;
      font-family: "PingFang SC";
      font-weight: 400;
      font-size: 16px;
      line-height: 22px;
      text-align: center;
      color: #666666;
      margin-bottom: 48px;
    }
    .system_bottom {
      width: 100%;
      height: 536px;
      display: flex;
      justify-content: center;
      align-items: center;
      background: url("../../../static/other/bg_system_bottom.png");
      background-repeat: no-repeat;
      background-size: cover;
      background-position: center 0;

      .system_center {
        width: 60%;
        height: 400px;
        background: #ffffff;
        border-radius: 8px;
        display: flex;
        flex-direction: row;
        align-items: center;
        justify-content: center;

        .system_img {
          width: 860px;
          height: 272px;
        }
      }

      .system_content_center {
        width: 65%;
        height: 400px;
        background: #ffffff;
        border-radius: 8px;
        display: flex;
        flex-direction: row;
        align-content: center;
        align-items: center;

        .service_content_img {
          height: 100%;
          margin-left: 40px;
        }

        .system_content_item {
          display: flex;
          flex-direction: row;

          .system_content_img {
            width: 20px;
            height: 20px;
            margin-right: 11px;
          }

          .system_content_text {
            font-family: "PingFang SC";
            font-weight: 400;
            font-size: 16px;
            line-height: 22px;
            text-align: center;
            color: #333333;
          }
        }
      }
    }
  }

  .core_advantage_parent {
    display: flex;
    flex-direction: column;
    align-items: center;
    .core_advantage_title {
      font-family: "PingFang SC";
      font-weight: 500;
      font-size: 28px;
      line-height: 39px;
      text-align: center;
      color: #333333;
      margin-top: 80px;
      margin-bottom: 48px;
    }

    .core_advantage_bottom {
      width: 100%;
      height: 536px;
      display: flex;
      justify-content: center;
      align-items: center;
      background: url("../../../static/other/bg_system_bottom.png");
      background-repeat: no-repeat;
      background-size: cover;
      background-position: center 0;

      .core_advantage_center {
        width: 60%;
        height: 400px;
        background: #ffffff;
        border-radius: 8px;
        display: flex;
        flex-direction: row;

        .core_advantage_item {
          display: flex;
          flex-direction: column;
          align-items: center;
          width: 25%;

          .core_advantage_item_img {
            width: 48px;
            height: 48px;
            margin-top: 36px;
            margin-bottom: 24px;
          }
          .core_advantage_item_title {
            font-family: "PingFang SC";
            font-weight: 500;
            font-size: 20px;
            line-height: 28px;
            margin-bottom: 12px;
            color: #000000;
          }
          .core_advantage_item_content {
            font-family: "PingFang SC";
            font-weight: 400;
            font-size: 16px;
            line-height: 24px;
            margin-left: 36px;
            margin-right: 36px;
            color: #666666;
          }
        }
        .line {
          height: 100%;
          width: 1px;
          background: #e5e7eb;
        }
      }
    }
  }

  .village_parent {
    display: flex;
    flex-direction: column;
    justify-content: center;
    align-items: center;

    .village_title {
      font-family: "PingFang SC";
      font-weight: 500;
      font-size: 28px;
      line-height: 39px;
      margin-top: 80px;
      margin-bottom: 8px;
      color: #333333;
    }
    .village_info {
      font-family: "PingFang SC";
      font-weight: 400;
      font-size: 16px;
      line-height: 22px;
      text-align: center;
      color: #666666;
      margin-bottom: 48px;
    }
    .village_bottom {
      width: 100%;
      height: 536px;
      display: flex;
      justify-content: center;
      align-items: center;
      background: url("../../../static/other/bg_village_bottom.png");
      background-repeat: no-repeat;
      background-size: cover;
      background-position: center 0;

      .village_center {
        width: 1080px;
        height: 400px;
        background: #ffffff;
        border-radius: 8px;
        display: flex;
        flex-direction: row;

        // 数字化乡村管理建设
        .village_construction_left {
          width: 50%;
          display: flex;
          flex-direction: column;
          padding-left: 80px;

          .village_construction_left_title {
            font-family: "PingFang SC";
            font-weight: 500;
            font-size: 20px;
            line-height: 28px;
            color: #333333;
            margin-top: 48px;
            margin-bottom: 32px;
          }
          .village_construction_left_img {
            width: 277px;
            height: auto;
          }
        }
        .village_construction_right {
          width: 50%;
          display: flex;
          flex-direction: column;
          .village_construction_right_title {
            font-family: "PingFang SC";
            font-weight: 500;
            font-size: 20px;
            line-height: 28px;
            color: #333333;
            margin-top: 48px;
            margin-bottom: 48px;
          }
          .village_construction_right_item {
            display: flex;
            flex-direction: row;
            .village_construction_right_item_img {
              width: 24px;
              height: 24px;
            }
            .village_construction_right_item_text {
              font-family: "PingFang SC";
              font-weight: 400;
              font-size: 16px;
              line-height: 22px;
              text-align: center;
              color: #333333;
            }
          }
        }

        // 连接性
        .village_connectivity {
          width: 33%;
          padding-top: 22px;

          .village_connectivity_title {
            font-family: "PingFang SC";
            font-weight: 500;
            font-size: 20px;
            line-height: 28px;
            margin-top: 48px;
            margin-bottom: 12px;
            color: #000000;
          }
          .village_connectivity_info {
            font-family: "PingFang SC";
            font-weight: 400;
            font-size: 16px;
            line-height: 24px;
            padding-right: 60px;
            color: #666666;
          }
        }
        .village_connectivity_bg {
          width: 33%;
          display: flex;
          justify-content: center;
          align-items: center;
          margin-left: 50px;
          margin-right: 90px;

          .village_connectivity_img {
            width: 313px;
            height: 248px;
          }
        }
      }
      .village_connectivity_padding {
        padding-left: 60px;
        padding-right: 30px;
      }

      .village_product_center {
        // width: 60%;
        .village_product_item {
          width: 256px;
          height: 360px;
          background: #ffffff;
          border-radius: 8px;
          display: flex;
          flex-direction: column;
          align-items: center;
          .village_product_item_img {
            width: 66px;
            height: 66px;
            margin-top: 65px;
            margin-bottom: 24px;
          }
          .village_product_item_title {
            font-family: "PingFang SC";
            font-weight: 500;
            font-size: 20px;
            line-height: 28px;
            text-align: center;
            color: #333333;
            margin-bottom: 12px;
          }
          .village_product_item_content {
            font-family: "PingFang SC";
            font-weight: 400;
            font-size: 16px;
            line-height: 22px;
            text-align: center;
            color: #666666;
          }
        }
      }
    }
  }
}
</style>